__turbopack_context__.v({
  "conditions__list": "ConditionsList-module-scss-module__BN283W__conditions__list",
});
